export const isEnvFlagOff = (value?: string) =>
  !value || value === 'disabled' || value === 'off' || value === '0';
